export default "__VITE_ASSET__HSmG9CkL__"